import { useEffect, useRef, useState } from "react";
import { fetchEquipment, fetchProductPlan } from "../../../api";
import { useTimelineMethods } from "./hooks";
import { useTimeline } from "../../../context/TimelineProvider";
import moment from "moment";
import { useIntervalAsync } from "../../../../../hooks/useInterval";

const useInitEffects = (divisionId) => {
  const {
    addGroups,
    visibleTimeStart,
    visibleTimeEnd,
    addSegments,
    selectedSegment,
    updateTimer,
    timer,
    lastClickTime,
    hash,
    updateHash,
  } = useTimeline();
  const { handleWheelEvent, handleDeleteSegment, resetTimeline } =
    useTimelineMethods(divisionId);

  useEffect(() => {
    const timelineElement = document.querySelector(".react-calendar-timeline");
    if (timelineElement) {
      timelineElement.addEventListener("wheel", handleWheelEvent);
    }

    return () => {
      if (timelineElement) {
        timelineElement.removeEventListener("wheel", handleWheelEvent);
      }
    };
  }, [visibleTimeStart, visibleTimeEnd]);

  useEffect(() => {
    fetchEquipment({ divisionId }).then((res) => {
      addGroups(
        res.data.map((eqItem) => ({
          id: eqItem.equipment_id,
          title: eqItem.name,
          height: 50,
          status: eqItem.status,
        }))
      );
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [divisionId]);

  async function getProductData(passedHash) {
    try {
      const response = await fetchProductPlan({ divisionId, hash: passedHash || hash }); // Асинхронный вызов
      const newHash = response?.data?.hash;

      if (newHash) {
        updateHash(response.data.hash); // Обновление хэша

        // Перезагружаем данные
        if (response.status === 200) {
          if (!hash || (hash && hash !== newHash)) {
            const newEquipment = await fetchEquipment({ divisionId });

            const newSegments = response.data.segments;

            resetTimeline();

            addGroups(
              newEquipment.data.map((eqItem) => ({
                id: eqItem.equipment_id,
                title: eqItem.name,
                height: 50,
                status: eqItem.status,
              }))
            );

            addSegments(
              newSegments.map((plan) => ({
                id: plan.segment_id,
                group: plan.equipment_id,
                title: plan.operation_name,
                start_time: moment(plan.start_time),
                end_time: moment(plan.end_time),
                order: plan.order_name,
                orderItemId: plan.order_item_id,
                quantity: plan.operation_quantity,
                style: {
                  background: plan.order_color ?? "green",
                  minHeight: "50px",
                },
              }))
            );
          }
        }
      } else {
        console.log("No new hash received");
      }
    } catch (error) {
      console.error("Error fetching product plan:", error);
    }
  }

  useEffect(() => {
    getProductData();
  }, []);

  useIntervalAsync(async () => {
    await getProductData();
  }, 5000);

  useEffect(() => {
    const handleKeyDown = async (e) => {
      if (e.key === "Delete") {
        await handleDeleteSegment();
        resetTimeline()
        // Обнуляем хеш таймлайнов, чтобы получить данные по новому
        await getProductData(null);
      }
    };

    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [selectedSegment]);

  // Рефреш таймлайнов через минуту, если была добавлена свободная для размещения зона
  useEffect(() => {
    if (lastClickTime) {
      if (timer) clearTimeout(timer);
      const timeout = setTimeout(() => {
        getProductData();
      }, 60000);

      updateTimer(timeout);
    }
  }, [lastClickTime]);

  return {};
};

export default useInitEffects;
